(() => {
  const bindGallery = (gallery) => {
    if (!gallery || gallery.dataset.zenitGalleryBound === 'true') return;

    const list = gallery.querySelector('[id^="Slider-Gallery-"]');
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    const current = gallery.querySelector('.slider-counter--current');
    const status = gallery.querySelector('[id^="GalleryStatus-"]');
    const previous = gallery.querySelector('[data-zenit-gallery-previous]');
    const next = gallery.querySelector('[data-zenit-gallery-next]');
    const dots = Array.from(gallery.querySelectorAll('[data-zenit-gallery-dot]'));
    if (!list || !previous || !next || dots.length === 0) return;

    gallery.dataset.zenitGalleryBound = 'true';
    let frame = null;
    let activeIndex = -1;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const getItems = () => Array.from(list.querySelectorAll('[data-media-id]'));

    const announce = (index) => {
      if (!status) return;
      const message = window.accessibilityStrings?.imageAvailable;
      status.textContent = message ? message.replace('[index]', String(index + 1)) : dots[index]?.ariaLabel || '';
    };

    const setActive = (item, shouldAnnounce = false) => {
      if (!item) return;
      const items = getItems();
      const index = items.indexOf(item);
      if (index < 0) return;
      const mediaId = item.dataset.mediaId;

      items.forEach((candidate) => candidate.classList.toggle('is-active', candidate === item));
      dots.forEach((dot) => {
        const active = dot.dataset.mediaId === mediaId;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      if (current) current.textContent = String(index + 1);
      previous.disabled = index === 0;
      next.disabled = index === items.length - 1;

      if (index !== activeIndex) {
        activeIndex = index;
        gallery.playActiveMedia?.(item);
        if (shouldAnnounce) announce(index);
      }
    };

    const goTo = (index, shouldAnnounce = true) => {
      const items = getItems();
      const targetIndex = Math.max(0, Math.min(index, items.length - 1));
      const item = items[targetIndex];
      if (!item) return;

      list.scrollTo({
        left: item.offsetLeft,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
      setActive(item, shouldAnnounce);
    };

    const syncFromScroll = () => {
      frame = null;
      const items = getItems();
      if (items.length === 0) return;
      const listLeft = list.getBoundingClientRect().left;
      const active = items.reduce((nearest, item) => {
        const distance = Math.abs(item.getBoundingClientRect().left - listLeft);
        return distance < nearest.distance ? { item, distance } : nearest;
      }, { item: items[0], distance: Number.POSITIVE_INFINITY }).item;
      setActive(active);
    };

    previous.addEventListener('click', () => goTo(activeIndex - 1));
    next.addEventListener('click', () => goTo(activeIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = getItems().findIndex((item) => item.dataset.mediaId === dot.dataset.mediaId);
        if (index >= 0) goTo(index);
      });
    });

    viewer?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    list.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(syncFromScroll);
    }, { passive: true });

    const observer = new MutationObserver(syncFromScroll);
    observer.observe(list, { childList: true });
    syncFromScroll();
  };

  const bindAll = (root = document) => root.querySelectorAll('[data-zenit-product-gallery]').forEach(bindGallery);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindAll(), { once: true });
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();
